export function usernameValidator(username) {
  if (!username) return "Username can't be empty.";
  return "";
}
